import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, LastPagingSetup, LocalService, NumericConfig, Paging } from '../../../service/local.service';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
  host: { '(document:click)': 'onShowHideOption($event,0,false)' }
})
export class PagingComponent implements OnInit {
  @Input() paging: Paging; @Input() IsShowDateRange: boolean = false; isShowDateRange: boolean = false; isShowMoreOptions: boolean = false;
  @Output() onPagingRefreshed = new EventEmitter(); @Output() onPagingPrint = new EventEmitter(); @Input() IsShowSingleCalender = false; @Input() IsShowSimpleCalenderRange = false; IsShowSingleCalenderClicked = false;
  config = {}; @Input() IsSimple = false; @Input() IsShowTotalCount = false; @Input() IsSimpleSearchBarReq = true; isShowSearchFilter = true; @Output() onDateSelected = new EventEmitter();
  @Output() onCountryChanged = new EventEmitter(); @Input() isShowFilterOption = true;
  isAutoRefreshEnabled: boolean = false; autoRefreshSeconds: number = 30; @Output() isUpdateDuringLanguageChange = true; isShowNavigation = true; isShowPrinter = false; @Output() onDownloadExcel = new EventEmitter(); isEnableShowMoreOptions = false; @Input() isTriggerOnOptionSelect = false; @Output() onShowGraph = new EventEmitter();
  allowedClasses = ['more_options_icon', 'date_range_icon', 'dp-picker-input', 'dp-calendar-day', 'dp-current-month', 'dp-calendar-nav-left', 'dp-calendar-nav-right', 'dp-nav-header-btn', 'dp-calendar-month', 'dp-current-location-btn', 'exclude_on_document_click'];
  lstSectionConfigKeys: string[] = ["paging"]; isShowSummary = false; @Output() onShoppingClicked = new EventEmitter();
  numericConfig: NumericConfig = {} as NumericConfig; @Input() isShowShoppingCart = false; @Input() countToShow = 0;
  numericConfigDefault: NumericConfig = { maxValue: 1000 } as NumericConfig;
  @Input() graphValue1: string; @Input() graphValue2: string; @Input() graphValue3: string;
  @Input() pageType: GeneralConfigType = GeneralConfigType.None;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.onSetDateConfig();
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.numericConfig.maxValue = this.paging.totalPage;
    if (this.pageType == GeneralConfigType.None) {
      this.pageType = this.paging.pageType;
    }
    switch (this.pageType) {
      case GeneralConfigType.PagingSalesReport: {
        this.IsShowDateRange = true;
        this.isEnableShowMoreOptions = true;
        //this.isShowMoreOptions = true;
        this.isShowSearchFilter = false;
        //this.isShowNavigation = false;
        this.isShowPrinter = true;
        this.IsSimple = false;
      } break;
      case GeneralConfigType.PagingNotifications:
      case GeneralConfigType.PagingMessageLogs: {
        this.IsSimple = true;
        this.IsSimpleSearchBarReq = false;
        this.IsShowSingleCalender = true;
      } break;
      case GeneralConfigType.PagingComplaints: {
        this.IsSimple = true;
      } break;
      case GeneralConfigType.PagingExploreItems: {
        this.IsSimple = true;
        this.isShowFilterOption = false;
      } break;
      case GeneralConfigType.PagingPrepaidDetail:
      case GeneralConfigType.PagingPaymentGateway:
      case GeneralConfigType.PagingPaidByCompanyDetail:
      case GeneralConfigType.PagingRentReceiptLogs:
      case GeneralConfigType.PagingSessions: {
        this.IsSimple = true;
        this.IsSimpleSearchBarReq = false;
      } break;
      case GeneralConfigType.PagingRequests: {
        this.isShowSearchFilter = false;
      } break;
    }
  }

  onPrint() {
    this.onPagingPrint.emit();
  }

  onSelect() {
    this.onDateSelected.emit();
  }

  onPagingRefresh(index: number, isTriggerEvent = true, isAutoRefresh = false) {
    this.IsShowSingleCalenderClicked = false;
    
    switch (index) {
      case 1: {
        this.paging.currentPage = this.paging.currentPage - 1;
      } break;
      case 2: {
        this.paging.currentPage = this.paging.currentPage + 1;
      } break;
      case 3: {
        if (this.paging.currentPage == null)
          this.paging.currentPage = 1;
        else if (this.paging.currentPage > this.paging.totalPage)
          this.paging.currentPage = this.paging.totalPage;
      } break;
      case 4: {
        this.paging.isReverseOrder = !this.paging.isReverseOrder;
      } break;
      case 5: {
        if (this.paging.dataPerPage > this.paging.totalCount)
          this.paging.dataPerPage = this.paging.totalCount;
      } break;
    }
    if (this.paging.currentPage == null)
      this.paging.currentPage = 1;
    if (this.paging.dataPerPage == null)
      this.paging.dataPerPage = 15;
    if (isTriggerEvent) {
      this.paging.isAutoRefresh = isAutoRefresh;
      this.onSetLastPaging();
      this.onPagingRefreshed.emit(this.paging);
    }
  }

  onSetDateConfig() {
    let today = this.localService.getDeviceDate();
    let date = today.getDate();
    let month = today.getMonth() + 1;
    let maxDt = (date < 10 ? ('0' + date) : date) + '-' + (month < 10 ? ('0' + month) : month) + '-' + today.getFullYear();
    this.config = { max: maxDt, min: this.localService.minDate, firstDayOfWeek: 'mo', showWeekNumbers: true, numOfMonthRows: 4 };
  }

  onShowHideOption(e, index = 0, isShow = true) {
    if (e != null) {
      let clickedClassName: string = e.target.className;
      if (this.allowedClasses.filter(x => clickedClassName.indexOf(x) > -1).length > 0)
        isShow = true;
    }
    switch (index) {
      case 0: {
        if (!isShow) {
          // this.isShowDateRange = false;
          this.isShowMoreOptions = false;
        }
      } break;
      case 1: {
        this.isShowDateRange = false;
        this.isShowMoreOptions = !this.isShowMoreOptions;
      } break;
      case 2: {
        this.isShowMoreOptions = false;
        this.isShowDateRange = !this.isShowDateRange;
        if (isShow) {
          setTimeout(() => {
            let elements = document.getElementsByClassName('dp-picker-input');
            if (elements.length > 0) {
              for (var i = 0; i < elements.length; i++) {
                elements[i].setAttribute('readonly', '');
              }
              //let element = elements[0] as HTMLInputElement;
              //element.focus();
            }
          }, 10);
        }
      } break;
    }
  }

  onGetPagingHeight(add = 3) {
    let height = add;
    let elementsFooters = document.getElementsByClassName('footer');
    if (elementsFooters != undefined && elementsFooters != null && elementsFooters.length > 0) {
      for (let i = 0; i < elementsFooters.length; i++) {
        let elementFooter = elementsFooters[i] as HTMLDivElement;
        height = elementFooter.offsetHeight + height;
      }
    }
    return height + 'px';
  }

  onMoreOptionsClicked(index) {
    switch (index) {
      case 1: {
        if (this.paging.data && this.paging.pageType == GeneralConfigType.PagingMembers) {
          this.configurationManagementService.getExcelData(this.paging, this.paging.data).subscribe(result => {
            this.localService.onDownloadFile(result);
          });
        } else {
          this.onDownloadExcel.emit();
        }
      } break;
      case 2: {
        this.onShowGraph.emit();
      } break;
    }
  }

  onToggleCheckbox(index) {
    switch (index) {
      case 1: {
        if (this.autoRefreshSeconds == null)
          this.autoRefreshSeconds = 30;
        else if (this.autoRefreshSeconds < 5)
          this.autoRefreshSeconds = 5;
        else if (this.autoRefreshSeconds > 60)
          this.autoRefreshSeconds = 60;
        this.isAutoRefreshEnabled = !this.isAutoRefreshEnabled;
        this.onShowHideOption(null, 0, false);
      } break;
    }
  }

  onAutoRefrehFocus() {
    this.isAutoRefreshEnabled = false;
  }

  onSetLastPaging() {
    if (this.localService.selected.user) {
      let item = this.localService.lastPageSetup.find(x => x.userId == this.localService.loggedMember.loggedMember.content.key && x.pageType == this.paging.pageType);
      if (item)
        item.paging = this.paging;
      else
        this.localService.lastPageSetup.push({ userId: this.localService.loggedMember.loggedMember.content.key, pageType: this.paging.pageType, paging: this.paging, additionalFilter: null } as LastPagingSetup);
    }
  }

  getFooterWidth() {
    return window.innerWidth > 700 ? '650px' : '100%';
  }

  onCountryUpdated(e) {
    this.onCountryChanged.emit(e);
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onShoppingClicked.emit();
      } break;
    }
  }
}
